import { RESET_POINT_OF_SALE_STATE } from '@dynameat/views/pointOfSale/mutationTypes';
import * as MutationTypes from './mutationTypes';

const resetData = (state) => {
  state.productBoostList = [];
};

const productBoostListSuccess = (state, productBoostList) => {
  state.productBoostList = productBoostList;
};

const createProductBoostListSuccess = (state, productBoost) => {
  state.productBoostList.push(productBoost);
  state.productBoostList.sort((a, b) => a.startDate.getTime() - b.startDate.getTime());
};

const removeProductBoostListSuccess = (state, productBoostGuid) => {
  state.productBoostList = state.productBoostList.filter((pb) => pb.guid !== productBoostGuid);
};

export const mutations = {
  [MutationTypes.PRODUCT_BOOST_LIST_SUCCESS]: productBoostListSuccess,
  [MutationTypes.CREATE_PRODUCT_BOOST_SUCCESS]: createProductBoostListSuccess,
  [MutationTypes.REMOVE_PRODUCT_BOOST_SUCCESS]: removeProductBoostListSuccess,
  [RESET_POINT_OF_SALE_STATE]: resetData,
};
